(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luvin-whatsapp-floating"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = 'a[href*="wa.me/"], a[href*="api.whatsapp.com/"]';

    const enrichProductLinks = () => {
      const title = document.querySelector('.product-info__title')?.textContent?.trim();
      if (!title) return;

      const message = `Olá! Preciso de ajuda com o produto ${title}. ${window.location.href}`;

      document.querySelectorAll(`.product-info__button ${selector}`).forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('text', message);
        link.href = url.toString();
        link.dataset.whatsappPlacement = 'product_help';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enrichProductLinks, { once: true });
    } else {
      enrichProductLinks();
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest(selector);
      if (!link) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'whatsapp_click',
        placement: link.dataset.whatsappPlacement || 'other',
        page_type: document.querySelector('.shopify-section--main-product') ? 'product' : 'other',
        page_url: window.location.href
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
